/**
 * Ítem 4: USD ingreso y egreso (F6 relajado).
 * Run: npx tsx --test src/lib/usdSoloIngreso.test.ts
 */

export type MonedaCaja = "ARS" | "USD";
export type SignoMovimiento = "Ingreso" | "Egreso";

export const MSG_USD_SOLO_INGRESO =
  "Un tipo en dólares solo puede usarse como Ingreso.";
export const MSG_EGRESO_USD_PROHIBIDO =
  "No se pueden registrar egresos en dólares.";

/** Ítem 4: USD admite Ingreso y Egreso. */
export function usdSoloIngreso(
  _tipo: SignoMovimiento,
  _moneda: MonedaCaja,
): boolean {
  return true;
}

/** Ítem 4: no forzar Ingreso ni ARS al elegir USD/Egreso. */
export function coerceUsdIngreso(
  tipo: SignoMovimiento,
  moneda: MonedaCaja,
): { tipo: SignoMovimiento; moneda: MonedaCaja } {
  return { tipo, moneda };
}

export function tipoMovimientoMoneda(tipo: {
  moneda?: string | null;
}): MonedaCaja {
  return String(tipo?.moneda || "ARS").toUpperCase() === "USD" ? "USD" : "ARS";
}
